import React from 'react';
import TextMessage from './text-message';
import ButtonIcon from './button-icon';
import { buttonClickHandler } from './button-click-handler';

function Card({ card, onSelect, disabled }) {
  const buttons = Array.isArray(card.buttons) ? card.buttons : [];

  return (
    <article
      className="flex w-72 flex-none snap-start flex-col overflow-hidden rounded-xl border border-hairline bg-elevated"
    >
      {card.image && (
        <img
          src={card.image}
          alt={card.title || ''}
          loading="lazy"
          className="h-36 w-full object-cover"
        />
      )}

      <div className="flex flex-1 flex-col p-4">
        {card.title && <h3 className="text-sm font-semibold text-ink">{card.title}</h3>}
        {card.description && (
          <p className="mt-1.5 line-clamp-4 text-[13px] leading-5 text-ink-muted">
            {card.description}
          </p>
        )}

        {buttons.length > 0 && (
          <div className="mt-auto flex flex-col gap-1.5 pt-4">
            {buttons.map((button, index) => (
              <button
                key={button.id || index}
                type="button"
                disabled={disabled}
                onClick={() => onSelect(button)}
                className="inline-flex items-center justify-center rounded-lg border border-hairline bg-surface
                  px-3 py-2 text-[13px] text-ink transition-colors hover:border-accent hover:text-accent
                  disabled:cursor-not-allowed disabled:opacity-50"
              >
                <ButtonIcon icon={button.icon} alt={button.title} />
                {button.title}
              </button>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default function Cards({ message = {}, onInvokeAction, disabled }) {
  const { cards, displayText, fallbackConfig } = message;
  const onClick = buttonClickHandler(onInvokeAction);
  const hasCards = Array.isArray(cards) && cards.length > 0;

  const onSelect = button => onClick(button.payload, button);
  const fallbackActions = fallbackConfig?.fallbackActions || [];

  return (
    <div className="w-full">
      {displayText && <TextMessage message={displayText} />}

      {hasCards && (
        <div className="hide-scrollbars -mx-1 mt-3 flex snap-x gap-3 overflow-x-auto px-1 pb-1">
          {cards.map((card, index) => (
            <Card key={card.id || index} card={card} onSelect={onSelect} disabled={disabled} />
          ))}
        </div>
      )}

      {fallbackConfig?.fallbackDescription && (
        <div className="mt-3">
          <TextMessage message={fallbackConfig.fallbackDescription} />
        </div>
      )}

      {fallbackActions.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {fallbackActions.map((action, index) => (
            <button
              key={action.id || index}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(action)}
              className="inline-flex items-center rounded-lg border border-hairline bg-elevated px-3.5 py-2
                text-sm text-ink transition-colors hover:border-accent hover:text-accent
                disabled:cursor-not-allowed disabled:opacity-50"
            >
              <ButtonIcon icon={action.icon} alt={action.title} />
              {action.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
